//lucide react icons
import { Wind, ThermometerSun, BetweenHorizonalEnd, ToggleLeft, Palette, MapPinCheck, Sun, Moon, Monitor, Check
, Menu, Settings,DollarSign, Bot, X,Smartphone,Cloud,Droplets,Thermometer,Gauge,Send, Image as ImageIcon,
ChevronDown, Globe, Search,  Image, Eye, Frown, Trash2, Users, User, Mail, Upload, ArrowLeft, CircleAlert, MoreVertical
 } from 'lucide-react';

export const Icons = {
Wind: (props:any) => <Wind className="h-5 w-5 text-gray-600" {...props} />,
ThermometerSun: (props:any) => <ThermometerSun className="h-5 w-5 text-gray-600" {...props} />,
BetweenHorizonalEnd: (props:any) => <BetweenHorizonalEnd className="h-5 w-5 text-gray-600" {...props} />,
ToggleLeft: (props:any) => <ToggleLeft className="h-5 w-5 text-gray-600" {...props} />,
Palette: (props:any) => <Palette className="h-5 w-5 text-gray-600" {...props} />,
MapPinCheck: (props:any) => <MapPinCheck className="h-5 w-5 text-gray-600" {...props} />,
Moon: (props:any) => <Moon className="h-5 w-5" {...props} />,
Sun: (props:any) => <Sun className="h-5 w-5" {...props} />,
Monitor: (props:any) => <Monitor className="h-4 w-4" {...props} />,
Check: (props:any) => <Check className="h-4 w-4" {...props} />,
Menu: (props:any) => <Menu className="h-6 w-6" {...props} />,
Settings: (props:any) => <Settings className="h-6 w-6" {...props} />,
DollarSign: (props:any) => <DollarSign className="h-6 w-6" {...props} />,
Smartphone:(props:any) => <Smartphone className="h-6 w-6" {...props} />,
Bot:(props:any) => <Bot className="h-6 w-6" {...props} />,
X:(props:any) => <X className="h-6 w-6" {...props} />,
Cloud:(props:any) => <Cloud className="h-6 w-6" {...props} />,
Droplets:(props:any) => <Droplets className="h-6 w-6" {...props} />,
Thermometer:(props:any) => <Thermometer className="h-6 w-6" {...props} />,
Gauge:(props:any) => <Gauge className="h-6 w-6" {...props} />,
Send:(props:any) => <Send className="h-6 w-6" {...props} />,
ImageIcon:(props:any) => <ImageIcon className="h-6 w-6" {...props} />,
ChevronDown:(props:any) => <ChevronDown className="h-6 w-6" {...props} />,
Globe:(props:any) => <Globe className="h-8 w-8" {...props} />,
Search:(props:any) => <Search className="h-8 w-8" {...props} />,
Image:(props:any) => <Image className="h-8 w-8" {...props} />,
Users:(props:any) => <Users className="h-8 w-8" {...props} />,
Trash2:(props:any) => <Trash2 className="h-8 w-8" {...props} />,
Eye:(props:any) => <Eye className="h-8 w-8" {...props} />,
Frown:(props:any) => <Frown className="h-8 w-8" {...props} />,
User:(props:any) => <User className="h-8 w-8" {...props} />, 
Mail:(props:any) => <Mail className="h-8 w-8" {...props} />,
Upload:(props:any) => <Upload className="h-8 w-8" {...props} />,
ArrowLeft:(props:any) => <ArrowLeft className="h-8 w-8" {...props} />,
CircleAlert:(props:any) => <CircleAlert className="h-8 w-8" {...props} />,
MoreVertical:(props:any) => <MoreVertical className="h-4 w-4" {...props} />
};